<script>
export default {
  name: 'HighlightedText',
  functional: true,
  props: {
    tag: {
      type: [Object, String],
      default: undefined
    },
    highlightClass: {
      type: [Object, Array, String],
      default: 'text-secondary'
    },
    /**
     * @type {String | VueI18n.TranslateResult}
     */
    text: {
      type: String,
      required: true
    }
  },
  render(h, { props: { tag, text, highlightClass }, slots, ...ctx }) {
    const chunks = text.split(/\*/g)
    chunks[1] = slots().default || h('span', { class: highlightClass }, chunks[1])
    return tag ? h(tag, ctx.data, chunks) : chunks
  }
}
</script>
